import { getAdvancedFilterRuleLabelFeedback } from './getAdvancedFilterRuleLabelFeedback'

type SetMetadataLabelParams = {
  metadataPrefix?: string
  metadata: any
  filter: any
  index: number
}

type SetMetadataListLabelParams = {
  metadataPrefix?: string
  metadata: any
  index: number
}

type GetFormatedMetadatasForTagParams = {
  metadataPrefix?: string
  metadata: any
  filter: any
}

function setMetadataLabel({ metadataPrefix, metadata, filter, index }: SetMetadataLabelParams) {
  let label = metadata[`info_${index}_label`]
  if (!label) label = metadata[`${metadataPrefix}_info_${index}_label`]
  return getAdvancedFilterRuleLabelFeedback(filter[`info_${index}_rule`] as string, label as string)
}

function setMetadataListLabel({ metadataPrefix, metadata, index }: SetMetadataListLabelParams) {
  let label = metadata[`info_${index}_label`]
  if (!label) label = metadata[`${metadataPrefix}_info_${index}_label`]
  return label
}

export function getMetadatasFilterTagsFeedbacks({ metadataPrefix = '', metadata, filter }: GetFormatedMetadatasForTagParams) {
  if (!metadata || !filter) return null

  return {
    info_1: `${setMetadataLabel({ metadata, metadataPrefix, filter, index: 1 })}: ${filter['info_1']}`,
    info_2: `${setMetadataLabel({ metadata, metadataPrefix, filter, index: 2 })}: ${filter['info_2']}`,
    info_3: `${setMetadataLabel({ metadata, metadataPrefix, filter, index: 3 })}: ${filter['info_3']}`,
    info_4: `${setMetadataLabel({ metadata, metadataPrefix, filter, index: 4 })}: ${filter['info_4']}`,
    info_5: `${setMetadataLabel({ metadata, metadataPrefix, filter, index: 5 })}: ${filter['info_5']}`,
    info_6: `${setMetadataLabel({ metadata, metadataPrefix, filter, index: 6 })}: ${filter['info_6']}`,
    info_7: `${setMetadataLabel({ metadata, metadataPrefix, filter, index: 7 })}: ${filter['info_7']}`,
    info_1_list: `${setMetadataListLabel({ metadata, metadataPrefix, index: 1 })}: ${filter['info_1_list']}`,
    info_2_list: `${setMetadataListLabel({ metadata, metadataPrefix, index: 2 })}: ${filter['info_2_list']}`,
    info_3_list: `${setMetadataListLabel({ metadata, metadataPrefix, index: 3 })}: ${filter['info_3_list']}`,
    info_4_list: `${setMetadataListLabel({ metadata, metadataPrefix, index: 4 })}: ${filter['info_4_list']}`,
    info_5_list: `${setMetadataListLabel({ metadata, metadataPrefix, index: 5 })}: ${filter['info_5_list']}`,
    info_6_list: `${setMetadataListLabel({ metadata, metadataPrefix, index: 6 })}: ${filter['info_6_list']}`,
    info_7_list: `${setMetadataListLabel({ metadata, metadataPrefix, index: 7 })}: ${filter['info_7_list']}`,
  }
}
